import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { refreshUser } = useAuth();
  const navigate = useNavigate();
  const polls = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      navigate("/feed");
      return;
    }
    let active = true;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refreshUser();
          setTimeout(() => navigate("/feed"), 1500);
          return;
        }
        polls.current++;
        if (polls.current > 20) {
          setStatus("timeout");
          return;
        }
        setTimeout(tick, 2000);
      } catch {
        setStatus("error");
      }
    };
    tick();
    return () => {
      active = false;
    };
  }, [sessionId, navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0c10] p-6">
      <div className="telesis-panel rounded p-8 max-w-md text-center">
        <p className="telesis-eyebrow">Membership</p>
        {status === "checking" && <p className="text-slate-200 mt-3">Confirming your 20.21 CAD subscription…</p>}
        {status === "paid" && <p className="text-emerald-300 mt-3 font-semibold">Welcome, member. Mentational Faculties unlocked.</p>}
        {status === "timeout" && (
          <>
            <p className="text-slate-300 mt-3">Payment confirmation is taking longer than expected.</p>
            <Link to="/feed" className="mt-4 inline-block text-yellow-400 underline">Continue to feed</Link>
          </>
        )}
        {status === "error" && <p className="text-rose-300 mt-3">Status check failed. Please re-open from your account.</p>}
      </div>
    </div>
  );
}
